<div *ngIf="paymentResult?.status === 'ERROR'">
    <div class="alertbox error">
        <div class="icon">
            <img src="assets/img/icon/error.png" alt="Error">
        </div>
        <h4>{{ "Error" | translate }}</h4>
        <p><b>{{ paymentResult.message | translate }}</b></p>
    </div>
    <div class="pButton">
        <button class="btn btn-primary" (click)="backToMerchant('fail')">{{ "Back to Merchant" | translate }}</button>
    </div>
</div>

<div *ngIf="paymentResult?.status === 'DECLINED'">
    <div class="alertbox error">
        <div class="icon">
            <img src="assets/img/icon/error.png" alt="Error">
        </div>
        <h4>{{ "Declined" | translate }}</h4>
        <p>
            <b>{{ "Your transaction has been declined" | translate }}</b>
        </p>
    </div>
    <div class="pButton">
        <button class="btn btn-primary" (click)="backToMerchant('fail')">{{ "Back to Merchant" | translate }}</button>
    </div>
</div>

<div *ngIf="(domain?.domain === 'jtnprocessing.com' && paymentResult?.status === 'APPROVED') || paymentResult?.status === 'WAITING'">
    <div class="alertbox" style="padding: 48px 24px;">
        <div class="icon">
            <div class="waiting-icon">
                <svg width="81" height="82" viewBox="0 0 81 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.93945 33.3063C8.33771 16.9567 22.826 4.67163 40.1836 4.67163C60.0646 4.67163 76.1814 20.7884 76.1814 40.6694C76.1814 58.027 63.8963 72.5153 47.5467 75.9135C49.7144 73.8536 51.5758 71.4744 53.0557 68.8513C59.9217 65.7101 65.4406 60.1336 68.5073 53.2268H56.9153C56.8686 51.5129 56.6788 49.8348 56.3574 48.2038H70.2357C70.8384 45.792 71.1584 43.2681 71.1584 40.6694C71.1584 38.0708 70.8384 35.5469 70.2357 33.135H55.4081C55.8073 35.5975 56.0365 38.0972 56.089 40.6171C56.0898 40.652 56.0898 40.6869 56.089 40.7217C56.0542 42.394 55.9415 44.0574 55.753 45.7069C54.6983 42.0448 52.9678 38.669 50.7053 35.7232C50.5975 34.8558 50.4664 33.9928 50.3126 33.135H48.4745C46.5973 31.1903 44.4608 29.4974 42.1208 28.112H49.1341C47.3276 21.9099 44.296 16.0957 40.1836 11.0298C36.8895 15.0876 34.2889 19.6255 32.456 24.4582C30.7828 24.1399 29.0606 23.9599 27.3017 23.9305C29.0136 19.0554 31.4258 14.4343 34.4776 10.219C24.4538 12.0856 16.1273 18.7796 12.0017 27.7973C9.37864 29.2772 6.99945 31.1386 4.93945 33.3063ZM68.5073 28.112H54.3452C52.6632 21.694 49.8019 15.623 45.8895 10.219C56.0296 12.1073 64.4328 18.9355 68.5073 28.112Z" fill="currentColor"/>
                    <circle cx="26.7891" cy="54.064" r="20.0918" stroke="currentColor" stroke-width="5.02295"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.2773 42.3438H29.3003V51.5525H35.1604V56.5754H31.8118C27.6506 56.5754 24.2773 53.2022 24.2773 49.041V42.3438Z" fill="currentColor"/>
                </svg>
            </div>
        </div>
        <h4 class="waiting-header">{{ "processing_payment" | translate }}</h4>
        <p class="waiting-text">
            {{ 'hang_tight' | translate }}
        </p>
    </div>
    <div class="pButton">
        <button class="btn btn-primary" (click)="backToMerchant()">
            {{ "view_transaction_details" | translate }}
        </button>
    </div>
</div>

<div *ngIf="domain?.domain === 'speedy.io' && paymentResult?.status === 'APPROVED' && paymentResult?.paymentMethod === 'CREDIT_CARD';">
    <div class="alertbox success" style="padding: 48px 24px;">
        <div class="icon">
            <img src="assets/img/icon/success.png" alt="Success">
        </div>
        <h4>{{ "Congratulations" | translate }}</h4>
        <p>
            {{ "payment_successfully_completed" | translate: {amount: transactionInfo?.amount | currency: transactionInfo?.currency:'symbol-narrow'} }}
            <br>
            <br>
            <span *ngIf="durationInfo && durationResponse?.durationType !== 'INSTANT'">
                {{ "payment_result_duration_speedy" | translate: {duration: durationInfo} }}
            </span>
            <br>
            <br>
            {{ 'This charge will appear on your invoice as PB*Speedy, PORTO ALEGRE' | translate }}
        </p>
    </div>
    <div class="pButton">
        <button class="btn btn-primary" (click)="backToMerchant()">{{ "Start discovering Speedy" | translate }}</button>
    </div>
</div>

<div *ngIf="paymentResult?.status === 'APPROVED' && domain?.domain !== 'speedy.io' && domain?.domain !== 'jtnprocessing.com'">
    <div class="alertbox" [ngClass]="'success'">
        <div class="icon">
            <img *ngIf="paymentResult?.status === 'APPROVED'" src="assets/img/icon/success.png" alt="Success" />
        </div>
        <h4>{{ "Congrats" | translate }}</h4>
        <p>
            <b> {{ transactionInfo?.amount }} {{ transactionInfo?.currency }} </b>
            {{ "transaction successfully completed"| translate }}
            <br>
            <span *ngIf="paymentResult?.status === 'APPROVED' && durationInfo && durationResponse?.durationType !== 'INSTANT'">
                {{ "Payment will credited within" | translate }}
                <b> {{ durationInfo }} </b>
            </span>
        </p>
    </div>
    <div class="pButton">
        <button class="btn btn-primary" (click)="backToMerchant()">{{ "view_transaction_details" | translate }}</button>
    </div>
</div>